const Logout = ({ color }) => (
    <svg width="28" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.04094 11.4167L7.12844 16.5392L6.53677 17.1267L1.38927 11.9433C0.870104 11.4233 0.870104 10.5767 1.3901 10.0558L6.53677 4.8725L7.12844 5.46L2.04094 10.5833H15.1659V11.4167H2.04094ZM10.9993 1V1.83333C16.0534 1.83333 20.1659 5.94583 20.1659 11C20.1659 16.0542 16.0534 20.1667 10.9993 20.1667V21C16.5134 21 20.9993 16.5142 20.9993 11C20.9993 5.48583 16.5134 1 10.9993 1Z" fill={color} stroke={color} stroke-width="0.2"/>
    </svg>
)

export default Logout